<template>
  <v-container>
    <div class="d-flex flex-column flex-sm-row align-center mt-8 mb-8">
      <span class="headline">Usuarios</span>
      <v-spacer></v-spacer>
      <v-text-field
        label="Buscar"
        v-model="searchText"
        @input="onChangeSearchText"
        prepend-inner-icon="search"
        clearable
        outlined
        hide-details
      ></v-text-field>
    </div>
    <div class="d-flex align-center">
      <!--       <div class="d-flex align-center">
        <span class="font-weight-media body-2">Ordenar:</span>
        <v-btn class="font-weight-light caption ml-2" text>
          <span>Alfabéticamente</span>
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>
      </div>-->
      <v-spacer></v-spacer>
    </div>
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="scrollInfiniteDisabled"
      infinite-scroll-distance="10"
    >
      <transition-group
        hide-on-leave
        name="slide-x-transition"
        tag="div"
        class="d-flex flex-wrap"
      >
        <v-col
          cols="12"
          sm="6"
          md="3"
          v-for="practitioner in practitionerList"
          :key="practitioner.id"
        >
          <PractitionerProfileCard
            :practitioner="practitioner"
            :to="'usuarios/' + practitioner.id"
          ></PractitionerProfileCard>
        </v-col>
      </transition-group>
    </div>
    <div v-if="loading">
      <transition-group
        hide-on-leave
        name="slide-x-transition"
        tag="div"
        class="d-flex flex-wrap"
      >
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="item of [1, 2, 3, 4, 5, 6]"
          :key="item"
        >
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
      </transition-group>
    </div>
  </v-container>
</template>

<script>
import PractitionerProfileCard from "./PractitionerProfileCard";
export default {
  components: { PractitionerProfileCard },
  data: () => ({
    dialogForm: false,
    snackForm: false,
    snackFormSuccess: false,
    loading: true,
    searchText: "",
    practitioner: {},
    practitionerList: [],
    page: 1,
    limit: 15,
    scrollInfiniteDisabled: false
  }),
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.scrollInfiniteDisabled = true;
        let { data: practitionerList } = await this.$http.get("practitioner", {
          params: {
            where: {
              name: {
                contains: this.searchText || ""
              }
            },
            sort: "name ASC",
            limit: this.limit,
            skip: (this.page - 1) * this.limit
          }
        });
        this.practitionerList.push(...practitionerList);
        if (practitionerList.length == this.limit) {
          setTimeout(() => {
            this.scrollInfiniteDisabled = false;
          }, 300);
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err);
      }
      this.loading = false;
    },
    async loadMore() {
      this.page++;
      this.getData();
    },
    async onChangeSearchText() {
      this.practitionerList = [];
      this.page = 1;
      this.getData();
    },
    async createPractitioner() {
      try {
        this.snackForm = true;
        this.dialogForm = false;
        let { data: created } = await this.$http.post(
          "practitioner",
          this.practitioner
        );
        this.snackFormSuccess = true;
        this.practitionerList.unshift(created);
      } catch (err) {
        // eslint-disable-next-line
        console.log(err);
      }
    }
  },
  mounted: function() {
    this.getData();
  },
  watch: {
    $route(to, from) {
      if (to.name == "Funcionario") {
        this.getData();
      }
      if (from.name == "Funcionario") {
        // TODO clean
      }
    }
  }
};
</script>
